import React from "react";
import HeadingSection from "../HeadingSection/HeadingSection";
import ContactForm from "../ContactUs/ContactForm";
import {Grid, Card, CardContent, Typography, CardActions, makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  card: {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  },
  cardContent: {
    flexGrow: 1,
  },
}));

const AboutUs = ({ dark, id }) => {
  const classes = useStyles();

  const cards = [
    {
      title: 'Автострахування',
      text: `Від обов'язкової автоцивілки до комплексного КАСКО з покриттям воєнних ризиків`,
      link: 'https://citybrokers.polis.ua/osago',
    },
    {
      title: 'Зелена картка',
      text: 'Безперешкодні поїздки за кордон з міжнародним страховим захистом',
      link: 'https://citybrokers.polis.ua/uk/greencard',
    },
    {
      title: 'Туристичне страхування',
      text: 'Повний захист у подорожах, включаючи медичні витрати та опційну страховку багажу',
      link: 'https://citybrokers.polis.ua/uk/travel',
    },
  ];

  return (
  <section className={"section" + (dark ? " section-dark" : "")}>
    <div className="container" >
      <div className="row" id='section1'>
        <HeadingSection title="ПРО НАС" tagline="У світі, де ризики є невід'ємною частиною повсякденного життя та бізнесу, City Brokers виступає вашим надійним партнером у світі страхування."/>
        <div style={{color:'black', marginLeft:'15px', marginRight:'15px', textAlign: 'justify'}}>
          <p style={{color:'black'}}>City Brokers - провідний страховий посередник з понад 20-річним досвідом, ми глибоко переконані що <i>«Будь-яку проблему, як і захворювання, дешевше попередити, ніж лікувати і усувати!"</i>  - Дар'я Рогова</p>
          <p style={{color:'black'}}>Саме тому наша місія — не просто продавати поліси, а забезпечувати всебічний та ефективний страховий захист, мінімізуючи вплив непередбачуваних подій.</p>
          <p style={{color:'black'}}>City Brokers - регіональна страхова та консалтингова агенція, яка спеціалізується на комплексному управлінні ризиками для юридичних та фізичних осіб. Ми пропонуємо нашим клієнтам рішення у сфері страхування та перестрахування, забезпечуємо повний цикл обслуговування: аналіз потенційних загроз, розробка програм страхування, формування страхової ємності та супровід процесу врегулювання збитків, включаючи представництво в судах та інших державних органах.</p>
          <p style={{color:'black'}}>Ми маємо системну практику у сфері спортивного страхування та пишаємося партнерством з олімпійцями.</p>
          <p style={{color:'black'}}>Наша унікальність полягає у здатності створити індивідуальні рішення, які точно відповідають вашим потребам.</p>
        </div>
      </div>
      <div className="row">
        <HeadingSection title="Що ми пропонуємо" />
          <div style={{color:'black', marginLeft:'15px', marginRight:'15px', textAlign: 'justify'}}>
            <p style={{color:'black'}}>Ми забезпечуємо повний цикл страхового обслуговування, від експертного аудиту потенційних загроз до супроводу врегулювання збитків, включаючи представництво ваших інтересів у судах.</p>
            <p style={{color:'black'}}>Це дозволяє нам гарантувати найвищий рівень страхового захисту та спокій для вашого бізнесу та особистого життя.</p>
            <p style={{color:'black'}}><b>Оформити страховку онлайн можна, перейшовши за посиланням нижче:</b></p>
            <div className="row" style={{ color:'black', marginLeft:'15px', marginRight:'15px', marginBottom: 80, textAlign: 'center' }}>
              <Grid container spacing={4} style={{ marginTop: 16 }}>
                {cards.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card className={classes.card} elevation={3}>
                      <CardContent className={classes.cardContent}>
                        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold', fontSize: '2rem', color: 'black', fontFamily: "'Poppins', sans-serif" }}>
                          {card.title}
                        </Typography>
                        <Typography variant="body2" style={{ fontSize: '1.5rem', color: 'black', fontFamily: "'Poppins', sans-serif" }}>
                          {card.text}
                        </Typography>
                      </CardContent>
                      <CardActions style={{ justifyContent: 'center', marginBottom: '20px' }}>
                        <button
                          type="button"
                          name="buy"
                          className="btn btn-color btn-circle"
                          onClick={() => window.open(card.link, '_blank', 'noopener,noreferrer')}
                        >
                          Купити
                        </button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </div>
            <div className="row" style={{ color:'black', marginLeft:'15px', marginRight:'15px', marginBottom: 80, textAlign: 'justify' }}>
              <p style={{color:'black'}}><b>Наша спеціалізація включає:</b></p>
              <ul style={{ paddingLeft: 20, color: 'black' }}>
                <li><b>Експертний аудит ризиків:</b> Глибокий аналіз потенційних загроз для вашого бізнесу та особистого майна.</li>
                <li><b>Повний супровід:</b> Від допомоги у виборі поліса до представництва ваших інтересів у врегулюванні страхових випадків та судах.</li>
                <li><b>Захист від наслідків воєнних дій:</b> Спеціалізовані пропозиції для страхування житла, комерційної нерухомості та КАСКО з покриттям воєнних ризиків.</li>
              </ul>
              <p style={{color:'black'}}><b>Розробка персоналізованих програм:</b> підбираємо персоналізовані страхові програми — для людей, бізнесу та майна, включаючи воєнні ризики та нестандартні кейси. Від класичних полісів до складних програм з урахуванням воєнних ризиків — <b>ми допоможемо обрати найкращий варіант серед сотень пропозицій ринку.</b></p>
            </div>
          </div>
      </div>
      <div className="row">
        <HeadingSection title="Маєте запит, що виходить за межі стандартних програм?" tagline="Залиште заявку, і ми зв’яжемося з вами найближчим часом">
          <ContactForm/>
        </HeadingSection>
      </div>
    </div>
  </section>
);
};

export default AboutUs;
